"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const material_1 = require("@mui/material");
const react_query_1 = require("@tanstack/react-query");
const currenciesQuery_1 = require("../../../../queries/currenciesQuery");
const teamQuery_1 = require("../../../../queries/teamQuery");
const teamApprovalLimitInput_1 = __importDefault(require("../../../organisms/createTeamModal/teamInfo/teamApprovalLimitInput"));
const ApprovalLimitFeatures = () => {
    const { data: teamId } = (0, react_query_1.useQuery)((0, teamQuery_1.selectedTeamIdQuery)('selectedTeamID'));
    const currentTeamId = teamId && teamId.length > 0 ? teamId?.[0] : '';
    const { data: currencies } = (0, react_query_1.useQuery)((0, currenciesQuery_1.getCurrenciesQuery)(currentTeamId));
    return ((0, jsx_runtime_1.jsx)(material_1.Grid, { style: {
            ...(globalThis.cardProvider.IS_HSBC_PROVIDER_SETUP
                ? {
                    paddingLeft: '70px',
                }
                : {}),
        }, size: 6, children: (0, jsx_runtime_1.jsx)(teamApprovalLimitInput_1.default, { currency: (currencies && currencies.length > 0 && currencies[0]) || 'N/A' }) }));
};
exports.default = ApprovalLimitFeatures;
